<template>
  <div class="tags-container">
    <el-tag closable class="tag" :class="{ 'tag-active': routeName === item.name }" v-for="item in routeHistory"
      :key="item.name" @click="tagTo(item)" @close="tagClose(item)">{{ item.name }}</el-tag>
  </div>
</template>
<script>
import { useRouteStore } from '@/store/route'

export default {
  data() {
    return {
      useRoute: null
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    routeHistory() {
      if (this.useRoute) {
        return this.useRoute.routeHistory
      } else {
        return []
      }
    },
  },
  watch: {
    $route(v) {
      if (v.name) {
        console.log(this.useRoute.routeHistory)
        let historyList = this.useRoute.routeHistory
        let ex = historyList.find((r) => r.path === v.path)
        if (!ex) {
          this.useRoute.addRouteHistory(v)
        }
      }
    },
  },
  methods: {
    tagTo(route) {
      route.meta['keepAlive'] = true
      this.$router.push({ path: route.path })
    },
    tagClose(route) {
      //如果关闭当前显示页
      if (route.name == this.$route.name) {
        //如果只打开了一个页面，关闭则显示空白页
        if (this.routeHistory.length === 1) {
          this.$router.push('/')
        } else {
          //如果打开了多个页面，关闭当前页面，则显示别的页面
          let displayIndex = 0
          this.routeHistory.forEach((r, index) => {
            //如果关闭的是第一个，则显示下一个
            //如果关闭的不是第一个，则显示上一个
            if (route.name === r.name) {
              if (index === 0) {
                displayIndex = 1
              } else {
                displayIndex = index - 1
              }
            }
          })
          let displayRoute = this.routeHistory[displayIndex]
          this.$router.push({ path: displayRoute.path })
        }
      }
      setTimeout(() => {
        // this.$store.dispatch('removeRouteHistory', route)
        this.useRoute.removeRouteHistory(route)
      }, 10)
    },
  },
  mounted() {
    this.useRoute = useRouteStore()
    let routeName = this.$route.name
    if (routeName) {
      this.useRoute.addRouteHistory(this.$route)
    }
  },
}
</script>
<style lang="scss" scoped>
.tags-container {
  overflow-x: auto;
  margin-top: 2px;
  height: 35px;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  background: white;

  :deep(.el-tag) {
    height: 25px;
    padding: 0 10px;
    line-height: 22.5px;
    border-radius: 1px;
    cursor: pointer;
  }

  .tag {
    color: black;
    margin-right: 10px;
  }

  .tag-active {
    background: #ee7031;
    color: white;
    :deep(.el-icon-close) {
      color: black !important;
      &:hover {
        background: white !important;
      }
    }
  }
}
</style>
